<template>
  <div>
    <keep-alive>
      <component :is="enter" :changes="changes"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      isActive: 0,
      rowObj:{}
    };
  },
  components: {
    // 考生组列表
    ExamGroupList: () => import("./components/ExamGroupList.vue"),
    // 成员管理
    MemberManage: () => import("./components/MemberManage.vue")
  },
  computed: {
    enter() {
      switch (this.isActive) {
        case 0:
          return "ExamGroupList"
          break
        case 1:
          return "MemberManage"
          break
      }
      return "ss"
    },
  },
  methods: {
    changes(index) {
       if (index == "0" && this.isActive == "1") {
        //这里代表新增返回
        console.log('新增返回');
        this.$children[0].Buriedpoint({
          code: "Examinee:ListOfGroups:members",
          parent_code: "Examinee:ListOfGroups",
        });
      }
      this.isActive = index
    },
  },
}
</script>
